import { faTelescope } from '@fortawesome/pro-duotone-svg-icons';
import { ConfigProvider } from 'antd';
import React, { FC, useState } from 'react';
import { FormattedMessage } from 'react-intl';
import { Project } from 'api/project';
import { EmptyStateIcon } from 'components/atoms/empty-state';
import { FilterBar } from 'components/molecules/filter-bar';
import { Sticky } from 'components/molecules/sticky';
import { getFilteredProjects } from 'utils/get-filtered-projects';
import { archivedProjectsListColumns } from './columns';
import {
  ArchivedProjectsWrapper,
  EmptyStateContent,
  EmptyStateWrapper,
  FilterBarWrapper,
  StyledSearchInput,
  StyledTable,
} from './styles';

export const ArchivedProjectsList: FC<{ data: Project[]; loading: boolean }> =
  ({ data, loading }) => {
    const [searchValue, setSearchValue] = useState<string>('');

    const filteredData = getFilteredProjects(data, searchValue);

    const onChange = (e) => setSearchValue(e.target.value);

    return (
      <>
        <Sticky top={56}>
          <FilterBarWrapper>
            <FilterBar.Primary />
            <FilterBar.Secondary>
              <StyledSearchInput
                disabled={loading}
                placeholder="search"
                size="small"
                onChange={onChange}
                value={searchValue}
                direction="right"
              />
            </FilterBar.Secondary>
          </FilterBarWrapper>
        </Sticky>
        <ArchivedProjectsWrapper>
          <ConfigProvider
            renderEmpty={() => (
              <EmptyStateWrapper>
                <EmptyStateContent
                  image={<EmptyStateIcon icon={faTelescope} />}
                  title={
                    <FormattedMessage id="projects.no_results.empty.title" />
                  }
                  message={
                    <FormattedMessage id="projects.archived_project.no_results_search" />
                  }
                />
              </EmptyStateWrapper>
            )}
          >
            <StyledTable
              dataSource={filteredData}
              columns={archivedProjectsListColumns}
              loading={loading}
              pagination={{
                position: ['bottomRight'],
                size: 'default',
                showSizeChanger: false,
                pageSize: 15,
                hideOnSinglePage: true,
              }}
              scroll={{ y: 'calc(100vh - 250px)', x: 1300 }}
              tableLayout="fixed"
              rowKey={(project) => project.projectId}
              size="small"
            />
          </ConfigProvider>
        </ArchivedProjectsWrapper>
      </>
    );
  };
